import { render, staticRenderFns } from "./personalInformationProtection.vue?vue&type=template&id=74bdde20&scoped=true&"
import script from "./personalInformationProtection.vue?vue&type=script&lang=js&"
export * from "./personalInformationProtection.vue?vue&type=script&lang=js&"
import style0 from "./personalInformationProtection.vue?vue&type=style&index=0&id=74bdde20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bdde20",
  null
  
)

export default component.exports